import React, { useState, useEffect } from 'react';

/* import { Link } from 'react-router-dom'; */

import Slider from "./Slider/Slider";
import Footer from "./Footer/Footer";

import parse from 'html-react-parser';

import Navbar from "./Navbar/Navbar";

import "./Pagina.css";

import * as Hosts from '../../Hosts';

import {
  set_language,
  reqGET,
  repo_img_link,
  repo_site_assets_link,
  content_language,
  translate,
  functionSendMail,
  reqPOST

} from '../../Utils';

import AssecImage from "./ASSEC_Image/Image"

// get our fontawesome imports
import { faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { language } from './WEBContent/Language';

import { Navigation, Pagination, Autoplay, Scrollbar, A11y, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';

import "swiper/swiper-bundle.min.css";

import Modal from "./Forms/OpinionModal"
import Loader from '../../loader';
import Swal from 'sweetalert2';
//import { el } from 'date-fns/locale';


const Pagina = props => {
  /* variável do tipo array */

  // const Slider = React.lazy(() => import("./Slider/Slider"));

  const [isloading, setLoading] = useState(true);

  const [lang, set_lang] = useState('pt');
  const [/*lang_id*/, set_lang_id] = useState('1');

  const [hiddenContent, /*sethiddenContent*/] = useState(false);

  const [dataParcerias, setDataParcerias] = useState([]);
  const [dataTestimony, setDataTestimony] = useState([]);

  //const [dataMote, setdataMote] = useState([]);
  const [dataRoutes, setdataRoutes] = useState([]);
  //const [dataRegiao, setdataRegiao] = useState([]);
  const [dataRegiaoImagens, setdataRegiaoImagens] = useState([]);

  const [show, setShow] = useState(false);

  let data_interface_nl = {
    id: '',
    info: {
        companycode: '',
        username: '',
        password: '',
        name: '',
        name_comercial: '',
        sector: '',
        segmentation: [],
        language: 'pt',
        type: '0',
        darkmode: false,
        rgpd: false,
        terms: false,
        marketing: false,
        ativo: true,
        observation: ''
    },
    addresses: [{
        village: '',
        city: '',
        type: [],
        region: '',
        country: '',
        apartado: '',
        localidade: '',
        contats: [],
        principal: '',
        observation: '',
        postal_code: '',
        street_name: '',
        address_detail: '',
    }],
    contacts: [{
        email: '',
        phone: '',
        principal: 'true',
        extensions: [],
        observation: '',
        mobile_phone: '',
        building_number: '',
        person_responsables: [{
            name: '',
            email: '',
            extensions: '',
            observation: '',
            mobile_phone: ''
        }],
    }],
    profile: { name: "entity_nl" },
    notifications: []
  }
  const [entity_nl, set_entity_nl] = useState(data_interface_nl);
  const [entity_nl_name, set_entity_nl_name] = useState('');
  const [entity_nl_email, set_entity_nl_email] = useState('');

  let getInfoParcerias = async () => {
    //setLoading(true)
    reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/94`)
      .then(res => {
        setDataParcerias(res.data)
        //console.log(res.data)
        setLoading(false)
        //calculo_margem()
      }).catch(erro => console.log('Erro1', erro))
  }

  let getTestimony = async () => {
    //setLoading(true)

    reqGET(`${Hosts.SIMCore_API}/web/content/type/${Hosts.companycode}/testimony`)
      .then(res => {
        setDataTestimony(res.data.filter(v => v.info.status === 'accepted'))
        setLoading(false)
        //console.log('Testemunhos: ', res.data)

      }).catch(erro => 
         Swal.fire({
          title: '',
          text: language[lang].label_erro_tempo_depois_de_horario_escolhido,
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: '#0095e8',
          confirmButtonText: language[lang].label_confirmar,
        })
          .then((result) => {
          })



      )
  }

  /*let getMote = async () => {
    //setLoading(true)
    reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/149`)
      .then(res => {
        setdataMote(res.data)
        //console.log(res.data)
        setLoading(false)
        //calculo_margem()
      })
      .catch(erro => console.log('Erro3', erro))
  }*/

  let getRoutes = async () => {
    //setLoading(true)
    await reqGET(`${Hosts.SIMCore_API}/platform/routes/sort/random`)
      .then(res => { 
          if (res.data.length > 0) {

              //var hoje = new Date();
              let aux = []
              res.data.forEach((v) => {

                aux.push(v)

              })
              setdataRoutes(aux)
              //set_list_content(res.data)
              //console.log('NOTICIAS', res.data)
    
              setLoading(false)
            }
      })
      .catch(erro => console.log('ERROR', erro))
  }

  let getRegiao = async () => {
    //setLoading(true)
    reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/159`)
      .then(res => {
        /*if(res.data.length > 0) {
            let aux = []
            res.data[0].content[0].media.image.forEach((v, index) => {
              if(index < 11) {
                    aux.push(v)
              }
            })
            setdataRegiaoImagens(aux)
        }*/
        //setdataRegiao(res.data)
        setdataRegiaoImagens(shuffle(res.data[0].content[0].media.image))
        setLoading(false)
        //calculo_margem()
      }).catch(erro => console.log('Erro1', erro))
  }

  const set_nl_contact = (e) => {
		const { value, name } = e.target;

    if(name === "name") {

      set_entity_nl_name(value)

    }
    else if(name === 'email') {

      set_entity_nl_email(value)

    }

    set_entity_nl(entity_nl)

  }

  const send_nl_contact = async () => {

    let terms = document.getElementById('terms_nl').checked

    if(entity_nl_name !== '' && entity_nl_email !== '' && terms) {

      entity_nl.info.name = entity_nl_name
      entity_nl.info.email = entity_nl_email
      entity_nl.info.companycode = '0000001'
      entity_nl.contacts[0].email = entity_nl_email
      
      entity_nl.info.rgpd = true
      entity_nl.info.terms = true
      entity_nl.info.marketing = true


      let res_c = await reqPOST(`${Hosts.SIMCore_API}/nl/entities`, entity_nl)
      if(parseInt(res_c.status) === 200) {

        let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +';border:1px solid transparent;border-collapse:collapse;">' +
            '<tr style="border-collapse: collapse;">' +
                '<td align="left" class style="padding:40px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                    '<div>'+
                        '<h4>'+ language[lang].nl_form +':</h4>'+
                        '<span><b>'+ language[lang].name +': </b><label>' + entity_nl_name + '</label></span>' +
                        '<br/>'+
                        '<span"><b>Email: </b><label>' + entity_nl_email + '</label></span>' +
                        '<br/>'+
                        '<br/>'+
                        '<span">' + language[lang].newsletter_reg + '</span>' +
                        '<br/>'+
                    '</div>'+
                '</td>' +
            '</tr>' +
        '</table>'

        let res = await functionSendMail(Hosts.contactFrom, [entity_nl_email], [Hosts.contactFrom], Hosts.webSiteTitle + ' - ' + language[lang].nl_form, mail_content, [])

        if(res === true) {
            document.getElementById('terms_nl').checked = false
            set_entity_nl_name('')
            set_entity_nl_email('')

            Swal.fire({
              title: language[lang].nl_form,
              text: language[lang].sent_successfully,
              icon: 'success',
              confirmButtonColor: '#08396a',
            })
          
        }
        else {

          Swal.fire({
            title: language[lang].nl_form,
            text: language[lang].sent_error,
            icon: 'warning',
            confirmButtonColor: '#08396a',
          })

        }
      }
      else if(parseInt(res_c.data) === 422) {
        
        Swal.fire({
          title: language[lang].nl_form,
          text: language[lang].nl_email_error_message,
          icon: 'warning',
          confirmButtonColor: '#08396a',
        })

      }
      else {

        Swal.fire({
          title: language[lang].nl_form,
          text: language[lang].sent_error,
          icon: 'warning',
          confirmButtonColor: '#08396a',
        })

      }

    }
    else {
      if(entity_nl_name === '' || entity_nl_email === '') {
        Swal.fire({
          title: language[lang].nl_form,
          text: language[lang].nl_fields_required,
          icon: 'warning',
          confirmButtonColor: '#08396a',
        })
      }
      else if(!terms) {
        Swal.fire({
          title: language[lang].nl_form,
          text: language[lang].nl_terms_required,
          icon: 'warning',
          confirmButtonColor: '#08396a',
        })
      }
      else {
        Swal.fire({
          title: language[lang].nl_form,
          text: language[lang].nl_fields_required,
          icon: 'warning',
          confirmButtonColor: '#08396a',
        })
      }
    }
  }

  useEffect(() => {

    //getInfoResort()
    //getMote()
    getRoutes()
    getRegiao()
    //getInfoBanner2()
    getInfoParcerias()
    //getInfoPlatforms()
    getTestimony()

    if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
      set_lang('pt')
      set_language('pt')
      set_lang_id('1')
    }
    else {
      set_lang(localStorage.getItem('lang'))
      content_language.forEach(el => {
        if (el.code === localStorage.getItem('lang')) {
          set_lang_id(el.id)
        }
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array; 
  }
  

  window.addEventListener('popstate', function (e) {
    //console.error('eeeeeeee', e)
    var state = e.state;
    if (state !== null) {
      //load content with ajax
    }
  });
  //window.addEventListener("focus", async() => await on_init(setLoading));
  return (
    isloading ?

      <Loader />

      :

      <div className='welcome'>
        <div className='d-none h1-heading'>
          <h1>{Hosts.webSiteTitle}</h1>
        </div>

        <Navbar pag_welcome={true} />

        <Slider />

        <section id="rotas" className="bg-color-gray-light py-3">
          <div className="container">
            <div className="row">
              <div className="col-12 my-3 my-md-5">
                <h3 className="titulo-primario">
                  <span>{language[lang].descubra_serra}</span>
                </h3>
              </div>
              {
              dataRoutes.map((v, key) => {
                // console.log('------------> V', v)
                
                let image_link = ''
                let image_name = ''
                let image_url = ''
                if(v.composicao[0]['multimedia'] !== undefined && v.composicao[0]['multimedia']['link_images'] !== undefined && v.composicao[0]['multimedia']['link_images'].length > 0 ) {
                  image_link = v.composicao[0].multimedia.link_images[0][0].link
                  // image_name = v.composicao[0].multimedia.link_images[0].name
                  // image_url = v.composicao[0].multimedia.link_images[0].url
                }
                return (
                  <div key={key} className="col-12 col-md-6 mb-5" style={{cursor: 'pointer'}} onClick={()=> window.open(("routes/" + v.id), "_self")}>
                    <AssecImage
                      linkImage={image_link !== undefined && image_link !== '' ? image_link : repo_img_link('nophoto.webp')}
                      width="640"
                      height="305"
                      fit='crop'
                      type='img'
                      sClass='img-fluid rounded mb-4'
                      alt={image_name}
                      title={image_url}
                    />
                    <div className="mb-4">
                      <h3 className="titulo-secundario">
                        {translate(v.composicao[0].descricao.nome, lang)}
                      </h3>
                      <p className="subtitulo-secundario">
                        {translate(v.composicao[0].descricao.observacao, lang)}
                      </p>
                    </div>
                    <div className='div-dados text-center bg-white d-flex justify-content-around'>
                      <div className='my-2'>
                        <strong>{language[lang].distancia}</strong>
                        <br />
                        {v.composicao[0].distancia}
                      </div>
                      <div className='my-2'>
                        <strong>{language[lang].elevacao}</strong>
                        <br />
                        {v.composicao[0].elevacao}
                      </div>
                      <div className='my-2'>
                        <strong>{language[lang].difficulty}</strong>
                        <br />
                        {translate(v.composicao[0].dificuldade, lang)}
                      </div>
                    </div>
                    <div className='div-texto limit-10-lines'>
                      {parse(translate(v.composicao[0].descricao.descricao, lang))}
                    </div>
                  </div>
                )
              })
              }
              <div className='col-12'>
                <div className="text-center mt-3">
                  <a href="routes/all" className="btn btn-primary" /*title={language[lang].learn_more}*/>
                    {language[lang].learn_more}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="categorias" className="pt-5">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className='col-12 col-md-6 col-lg-6 col-xl-3 mb-3' style={{cursor: 'pointer'}} onClick={()=> window.open(("restaurant/all"), "_self")}>
                  <div className='pt-3 px-3 pb-3' style={{ backgroundImage: `url(` + repo_site_assets_link("restauracao.jpg") + `)`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <div className='pt-5 mr-5'>
                      <div className='pt-5 mr-3 mr-sm-5 mr-md-3 mr-lg-3'>
                        <div className='mt-5 mr-5 p-3 text-white text-uppercase bg-restauracao'>
                          <img className='img-fluid ml-3' alt={language[lang].restauracao} style={{maxHeight: '40px'}} src={repo_site_assets_link("restauracao.svg")} />
                          <br />
                          {language[lang].restauracao}
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
              <div className='col-12 col-md-6 col-lg-6 col-xl-3 mb-3' style={{cursor: 'pointer'}} onClick={()=> window.open(("accommodation/all"), "_self")}>
                <div className='pt-3 px-3 pb-3' style={{ backgroundImage: `url(` + repo_site_assets_link("alojamento.jpg") + `)`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <div className='pt-5 mr-5'>
                    <div className='pt-5 mr-3 mr-sm-5 mr-md-3 mr-lg-3'>
                      <div className='mt-5 mr-5 p-3 text-white text-uppercase bg-alojamento'>
                        <img className='img-fluid ml-3' alt={language[lang].alojamento} style={{maxHeight: '40px'}} src={repo_site_assets_link("alojamento.svg")} />
                        <br />
                        {language[lang].alojamento}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-12 col-md-6 col-lg-6 col-xl-3 mb-3' style={{cursor: 'pointer'}} onClick={()=> window.open(("touristic/all"), "_self")}>
                <div className='pt-3 px-3 pb-3' style={{ backgroundImage: `url(` + repo_site_assets_link("oferta_turistica.jpg") + `)`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <div className='pt-5 mr-5'>
                    <div className='pt-5 mr-3 mr-sm-5 mr-md-3 mr-lg-3'>
                      <div className='mt-5 mr-5 p-3 text-white text-uppercase bg-oferta-turistica'>
                        <img className='img-fluid ml-3' alt={language[lang].touristic_offer} style={{maxHeight: '40px'}} src={repo_site_assets_link("oferta_turistica.svg")} />
                        <br />
                        {language[lang].touristic_offer}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className='col-12 col-md-6 col-lg-6 col-xl-3 mb-3' style={{cursor: 'pointer'}} onClick={()=> window.open(("events/all"), "_self")}>
                <div className='pt-3 px-3 pb-3' style={{ backgroundImage: `url(` + repo_site_assets_link("eventos.jpg") + `)`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <div className='pt-5 mr-5'>
                    <div className='pt-5 mr-3 mr-sm-5 mr-md-3 mr-lg-3'>
                      <div className='mt-5 mr-5 p-3 text-white text-uppercase bg-eventos'>
                        <img className='img-fluid ml-3' alt={language[lang].eventos} style={{maxHeight: '40px'}} src={repo_site_assets_link("eventos.svg")} />
                        <br />
                        {language[lang].eventos}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-12 col-md-6 col-lg-6 col-xl-3 mb-3' style={{cursor: 'pointer'}} onClick={()=> window.open(("animation/all"), "_self")}>
                <div className='pt-3 px-3 pb-3' style={{ backgroundImage: `url(` + repo_site_assets_link("animacao.jpg") + `)`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <div className='pt-5 mr-5'>
                    <div className='pt-5 mr-3 mr-sm-5 mr-md-3 mr-lg-3'>
                      <div className='mt-5 mr-5 p-3 text-white text-uppercase bg-animacao'>
                        <img className='img-fluid ml-3' alt={language[lang].animacao} style={{maxHeight: '40px'}} src={repo_site_assets_link("animacao.svg")} />
                        <br />
                        {language[lang].animacao}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="regiao" className='py-3'>
          <div className="container-fluid">
            <div className='row'>
              <div className="container">
                <div className="row">
                  <div className="col-12 my-3 my-md-5">
                    <h3 className="titulo-primario">
                      <span>{language[lang].viva_usufrua}</span>
                    </h3>
                  </div>
                </div>
              </div>
              <div className="container-fluid">
                <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-6 justify-content-center">
                  {
                  //dataRegiao.map((v, _) => {
                    //return (
                      dataRegiaoImagens.map((v2, key2) => {
                      //shuffle(v.content[0].media.image).map((v2, key2) => {
                      // (v.content[0].media.image).map((v2, key2) => {
                        return (
                          key2 < 12 ?
                            <div key={key2} className="col p-0">
                              <div className="partner-image position-relative">
                                {
                                  <a
                                    href={v2.link}
                                    data-fancybox="gallery"
                                    data-caption={(v2.link.includes(v2.name) || v2.name.includes('webp') || v2.name.includes('jpg') || v2.name.includes('png')) ? '' : v2.name}
                                  >
                                    <AssecImage
                                      linkImage={v2.link !== undefined ? v2.link : repo_img_link('nophoto.png')}
                                      width="400"
                                      height="400"
                                      fit='crop'
                                      type='img'
                                      sClass='img-fluid'
                                      alt={v2.name}
                                      title={(v2.link.includes(v2.name) || v2.name.includes('webp') || v2.name.includes('jpg') || v2.name.includes('png')) ? '' : v2.name}
                                    />
                                  </a>
                                }
                              </div>
                            </div>
                          :
                            null
                        )
                      })
                    //)
                  //})
                  }
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="partners" className='py-5'>
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-10 mx-auto">
                <div className="row align-items-center">
                  <div className="col-12 col-md-7 col-lg-8 d-none d-sm-block px-5">
                    <div className='row'>
                      <div className='col-12 col-md-6 p-1'>
                        <img src={repo_site_assets_link("partner_animation_wide.jpg")} alt={language[lang].animacao} title={language[lang].animacao} className="img-fluid rounded-10" />
                      </div>
                      <div className='col-12 col-md-6 p-1'>
                        <img src={repo_site_assets_link("partner_restaurant_wide.jpg")} alt={language[lang].restauracao} title={language[lang].restauracao} className="img-fluid rounded-10" />
                      </div>
                      <div className='col-12 col-md-6 p-1'>
                        <img src={repo_site_assets_link("partner_accommodation_wide.jpg")} alt={language[lang].alojamento} title={language[lang].alojamento} className="img-fluid rounded-10" />
                      </div>
                      <div className='col-12 col-md-6 p-1'>
                        <img src={repo_site_assets_link("partner_event_wide.jpg")} alt={language[lang].eventos} title={language[lang].eventos} className="img-fluid rounded-10" />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-5 col-lg-4 px-3 py-5 bg-color-gray-light rounded-10 text-center">
                    <p>{parse(language[lang].partners_text)}</p>
                    <h3 className="titulo-secundario mt-4">
                      {parse(language[lang].partners_title)}
                    </h3>
                    <div className="text-center mt-4">
                      <a href="contactos" className="btn btn-primary">
                        {language[lang].partners_button}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="app" className='py-5'>
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-10 col-xl-8 offset-sm-1 offset-xl-2">
                <div className="row align-items-center rounded-10">
                  <div className="col-12 col-md-5 col-lg-4">
                    <h3 className="titulo-secundario">
                      {parse(language[lang].download_app_title)}
                    </h3>
                    <p className="mt-4">{parse(language[lang].download_app)}</p>
                    <a href="https://play.google.com/store/apps/details?id=com.desafiosdeinverno.umaestrelamaior" title="App Google Play" target="_blank" rel="noreferrer" >
                      <img src={repo_site_assets_link("android_100px.svg")} alt="App Google Play"title="App Google Play" className="img-fluid mr-1" />
                    </a>
                    <a href="https://apps.apple.com/us/app/umaestrelamaior/id6502462233" title="App Store" target="_blank" rel="noreferrer" >
                      <img src={repo_site_assets_link("ios_100px.svg")} alt="App Store" title="App Store" className="img-fluid" />
                    </a>

                  </div>
                  <div className="col-12 col-md-7 col-lg-8 p-0 d-none d-sm-block">
                    {/*<div style={{ backgroundImage: `url(` + repo_site_assets_link("testemunhos_image.jpg") + `)` }} alt={language[lang].testimonials} title={language[lang].testimonials} className="img-fluid background-image rounded-20" ></div>*/}
                    <img src={repo_site_assets_link("imagem_app.jpg")} alt={language[lang].download_app_title} title={language[lang].download_app_title} className="img-fluid rounded-10" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="newsletter" className="parallax" style={{ backgroundImage: `url(` + repo_site_assets_link("banner_newsletter.jpg") + `)` }}>
          <div className="container-fluid py-5 overlay-img">
            <div className="row">
              <div className="container">
                <div className="row">
                  <div className="col-12 my-3 my-md-5">
                    <h3 className="titulo-primario">
                      <span>{language[lang].newsletter}</span>
                    </h3>
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-12 text-center text-white">
                    <div className='mb-3'>{language[lang].newsletter_txt}</div>
                    <div className="text-center d-flex justify-content-center mb-3">
                      <div className="form-row flex-column flex-md-row">
                        <div className="col form-group mb-md-0">
                          <input name="name" value={entity_nl_name} type="text" style={{width: '100%', maxWidth: '250px'}} className="form-control" placeholder={language[lang].name_placeholder} onChange={(e) => set_nl_contact(e)} />
                        </div>
                        <div className="col form-group mb-md-0">
                          <input name="email" value={entity_nl_email} type="email" style={{width: '100%', maxWidth: '250px'}} className="form-control" placeholder={language[lang].email_placeholder} onChange={(e) => set_nl_contact(e)} />
                        </div>
                        <div className="col-auto">
                          <button className="btn btn-primary rounded" type="button" onClick={() => send_nl_contact()}>{language[lang].subscribe}</button>
                        </div>
                      </div>
                    </div>
                    <div className="form-group custom-control custom-checkbox mb-0 mt-2">
                      <input type="checkbox" id="terms_nl" name="terms_nl" className="custom-control-input" />
                      <label className="custom-control-label" htmlFor="terms_nl">{language[lang].agree_terms_conditions}</label>&nbsp;
                      <a href={Hosts.WEB_SITE_URI + "terms-conditions"} target="_blank" rel="noreferrer">{language[lang].terms_conditions_link}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {
        hiddenContent ?
          <div>
            <section id="info_resort_fixed" className='d-none'>

              {/*<a href={Hosts.WEB_SITE_URI + 'mapa_pistas/'} className="text-decoration-none" title={language[lang].resort_serra_da_estrela}>
                <div className="round-card btn_04 text-center">
                  <div className='d-inline-flex'>
                    <div className='d-flex align-items-center justify-content-center mr-2'>
                      <img src={repo_site_assets_link("escola.svg")} alt={language[lang].resort_serra_da_estrela} title={language[lang].resort_serra_da_estrela} />
                    </div>
                    <div className='info-content p-2'>
                      <div className='titulo-secundario'>{language[lang].current_state}&#58;&nbsp;</div>
                      <div className={dataPistas.filter(v => v.state === true).length > 0 ? 'font-weight-bold text-uppercase text-success' : 'font-weight-bold text-uppercase text-danger'}>
                        {dataPistas.filter(v => v.state === true).length > 0 ? language[lang].open : language[lang].closed}
                      </div>
                    </div>
                  </div>
                </div>
              </a>

              <a href="https://www.meteoestrela.pt/previsoes/neve/" title={language[lang].meteorology} target="_blank" rel="noreferrer" className="text-decoration-none">
                <div className="round-card btn_01 text-center">
                  <div className='d-inline-flex'>
                    <div className='d-flex align-items-center justify-content-center mr-2'>
                      <img src={repo_site_assets_link("meteorologia.svg")} alt={language[lang].temperature} title={language[lang].temperature} />
                    </div>
                    <div className='info-content p-2'>
                      <h6 className="titulo-secundario">{language[lang].temperature}</h6>
                      <div className="numbers">
                        <span>{dataTemperature.min}ºC</span>
                        &nbsp;&#47;&nbsp;
                        <span>{dataTemperature.max}ºC</span>
                      </div>
                      <div style={{ color: 'var(--body)'}}>
                        <span className="mr-3">min</span>
                        <span className="ml-3">max</span>
                      </div>
                    </div>
                  </div>
                </div>
              </a>

              <a href={Hosts.WEB_SITE_URI + 'mapa_pistas/'} className="text-decoration-none" title={language[lang].tracks}>
                <div className="round-card btn_02 text-center">
                  <div className='d-inline-flex'>
                    <div className='d-flex align-items-center justify-content-center mr-2'>
                      <img src={repo_site_assets_link("pistas.svg")} alt={language[lang].tracks} title={language[lang].tracks} />
                    </div>
                    <div className='info-content p-2'>
                      <h6 className="titulo-secundario">{language[lang].tracks}</h6>
                      <div className="numbers">
                        <span>{dataPistas.filter(v => v.state === true).length}</span>
                        &nbsp;&#47;&nbsp;
                        <span style={{ color: 'var(--body)'}}>{dataPistas.length}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              
              <a href={Hosts.WEB_SITE_URI + 'mapa_pistas/'} className="text-decoration-none" title={language[lang].mechanical_means}>
                <div className="round-card btn_03 text-center mb-0">
                  <div className='d-inline-flex'>
                    <div className='d-flex align-items-center justify-content-center mr-2'>
                      <img src={repo_site_assets_link("meios-mecanicos.svg")} alt={language[lang].mechanical_means} title={language[lang].mechanical_means} />
                    </div>
                    <div className='info-content p-2'>
                      <h6 className="titulo-secundario">{language[lang].mechanical_means}</h6>
                      <div className="numbers">
                        <span>{dataMeios.filter(v => v.state === true).length}</span>
                        &nbsp;&#47;&nbsp;
                        <span style={{ color: 'var(--body)'}}>{dataMeios.length}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </a>*/}
            </section>

            <section id="info_resort" className='d-none'>
              {/*<div className="container-fluid py-5">
                <div className="container">
                  <div className="row">
                    <div className="col-12 mt-5 text-center">
                      <h3 className="titulo-primario">
                        {language[lang].resort_serra_da_estrela}
                      </h3>
                      <div className='current_state my-3'>
                        <span className='titulo-secundario'>
                          {language[lang].current_state}&#58;&nbsp;
                        </span>
                        <span className={dataPistas.filter(v => v.state === true).length > 0 ? 'font-weight-bold text-uppercase text-success' : 'font-weight-bold text-uppercase text-danger'}>
                          {dataPistas.filter(v => v.state === true).length > 0 ? language[lang].open : language[lang].closed}
                        </span>
                      </div>
                      <p>{language[lang].latest_update}&#58;&nbsp;{dataLatestUpdateDate}&nbsp;{language[lang].at}&nbsp;{dataLatestUpdateHour}</p>
                    </div>

                    <div className="col-12 mt-4">
                      <div className="row justify-content-evenly no-gutters">
                        <div className="round-card text-center">
                          <img src={repo_site_assets_link("meteorologia.svg")} alt={language[lang].temperature} title={language[lang].temperature} className="img-fluid" />
                          <h6 className="titulo-secundario">{language[lang].temperature}</h6>
                          <div className="numbers">
                            <span>{dataTemperature.min}ºC</span>
                            &nbsp;&#47;&nbsp;
                            <span>{dataTemperature.max}ºC</span>
                          </div>
                          <div>
                            <span className="mr-3">min</span>
                            <span className="ml-3">max</span>
                          </div>
                        </div>
                        <a href={Hosts.WEB_SITE_URI + 'mapa_pistas/'} className="text-decoration-none" title={language[lang].tracks}>
                          <div className="round-card text-center">
                            <img src={repo_site_assets_link("pistas.svg")} alt={language[lang].tracks} title={language[lang].tracks} className="img-fluid" />
                            <h6 className="titulo-secundario">{language[lang].tracks}</h6>
                            <div className="numbers">
                              <span>{dataPistas.filter(v => v.state === true).length}</span>
                              &nbsp;&#47;&nbsp;
                              <span style={{ color: 'var(--body)'}}>{dataPistas.length}</span>
                            </div>
                          </div>
                        </a>
                        
                        <a href={Hosts.WEB_SITE_URI + 'mapa_pistas/'} className="text-decoration-none" title={language[lang].mechanical_means}>
                          <div className="round-card text-center">
                            <img src={repo_site_assets_link("meios-mecanicos.svg")} alt={language[lang].mechanical_means} title={language[lang].mechanical_means} className="img-fluid" />
                            <h6 className="titulo-secundario">{language[lang].mechanical_means}</h6>
                            <div className="numbers">
                              <span>{dataMeios.filter(v => v.state === true).length}</span>
                              &nbsp;&#47;&nbsp;
                              <span style={{ color: 'var(--body)'}}>{dataMeios.length}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>*/}
            </section>

            <section id="app" className="parallax d-none" /*style={{ backgroundImage: `url(` + repo_img_link("banner-plataformas.png") + `)` }}*/>
              <div className="container-fluid py-5">
                <div className="container mb-4">
                  <div className="row">
                    <div className="col-12 text-center">
                      {/*dataPlatform.map((v, key) => {
                        //console.log('------------> V', v)
                        return (
                          <div key={key}>
                            <div className="mb-5">
                              <h3 className="titulo-primario">
                                {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title))}
                              </h3>
                              <p className="subtitulo-secundario">
                                {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].subtitle : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].subtitle === undefined || v.content[0].language[lang_id].subtitle === '' ? v.content[0].subtitle : v.content[0].language[lang_id].subtitle))}
                              </p>
                            </div>
                            <div className="column-count-2 text-left">
                              {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].text === undefined || v.content[0].language[lang_id].text === '' ? v.content[0].text : v.content[0].language[lang_id].text))}
                            </div>
                            <div className="row">
                              {v.content.slice(1).map((v2, key2) => {
                                let color = key2 === 1 ? '' : (key2 === 0 ? '-red' : '-orange');
                                return (
                                  //console.log('PROJECT', v.content[0].text)
                                  <div className="col-12 col-lg-4 mt-4 mt-sm-0" key={key2} >
                                    <img className="my-3" src={v2.media.image[0].link} alt={v2.title} height="80px" />
                                    <p className="titulo-primario mb-3">{v2.title}</p>
                                    {parse(v2.text)}
                                    <div className="mt-4">
                                      <a href="." className={"color" + color}>
                                        {language[lang].go_platform}
                                        <FontAwesomeIcon className="ml-2" icon={faLongArrowAltRight} />
                                      </a>
                                    </div>
                                  </div>
                                )
                              })
                              }
                            </div>
                          </div>
                        )
                      })*/
                      }
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="programas" className='d-none'>
              <div className="container-fluid py-5">
                <div className="container">
                  <div className="row">
                    <div className="col-12 my-5">
                      <h2 className="titulo-primario">
                        {language[lang].programs}
                      </h2>
                      <h1 className="vertical-title-left">
                        {language[lang].programs}
                      </h1>
                    </div>
                    <div className="col-12">
                      <div className="swiper swiper-container swiper-programas">
                        <Swiper
                          modules={[Navigation, Autoplay, Pagination, Scrollbar, A11y, EffectFade]}
                          spaceBetween={15}
                          //slidesPerView={3}
                          //navigation={banner.length > 1 ? true : false}
                          /*navigation={{
                              nextEl: '.swiper-programas-button-next',
                              prevEl: '.swiper-programas-button-prev',
                          }}*/
                          loop={false}
                          speed={7000}
                          autoplay={{
                            delay: 5000,
                            disableOnInteraction: false
                          }}
                          //effect="fade"
                          //pagination={banner.length > 1 ? true : false}
                          pagination={{
                            el: '.swiper-pagination-programas',
                            clickable: true
                          }}
                          breakpoints={{
                            // when window width is >= 0px
                            0: {
                              slidesPerView: 1,
                            },
                            // when window width is >= 768px
                            768: {
                              slidesPerView: 2,
                            },
                            992: {
                              slidesPerView: 3,
                            },
                            1200: {
                              slidesPerView: 3,
                            },
                          }}
                        /*scrollbar={{ draggable: true }}*/
                        //onSwiper={(swiper) => console.log(swiper)}
                        //onSlideChange={() => console.log('slide change')}
                        >
                          <SwiperSlide>
                            <div className="card border-0">
                              <div className="product-image position-relative">
                                <a title="Programa1" href="#programas">
                                  {/*<img src={repo_site_assets_link("programa1.jpg")} alt="Programa1" title="Programa1" className="img-fluid" />*/}
                                  <div style={{ backgroundImage: `url(` + repo_site_assets_link("programa1.jpg") + `)` }} alt="Programa1" title="Programa1" className="img-fluid background-image"></div>
                                </a>

                              </div>
                              <div className="product-content p-3 bg-color-gray-light">
                                <div className="info mb-4">
                                  <span className="product-name">Forfait 2 dias</span>
                                  &nbsp;&#47;&nbsp;
                                  <span className="product-group">Adulto</span>
                                  <div className="price float-right">45,00€</div>
                                </div>
                                <button className="btn btn-primary float-right">{language[lang].learn_more}</button>
                              </div>
                            </div>

                          </SwiperSlide>
                          <SwiperSlide>
                            <div className="card border-0">
                              <div className="product-image position-relative">
                                <a alt="Programa2" title="Programa2" href="#programas">
                                  {/*<img src={repo_site_assets_link("programa2.jpg")} alt="Programa2" title="Programa2" className="img-fluid" />*/}
                                  <div style={{ backgroundImage: `url(` + repo_site_assets_link("programa2.jpg") + `)` }} alt="Programa2" title="Programa2" className="img-fluid background-image"></div>

                                </a>

                              </div>
                              <div className="product-content p-3 bg-color-gray-light">
                                <div className="info mb-4">
                                  <span className="product-name">Forfait diário</span>
                                  &nbsp;&#47;&nbsp;
                                  <span className="product-group">Família</span>
                                  <div className="price float-right">78,00€</div>
                                </div>
                                <button className="btn btn-primary float-right">{language[lang].learn_more}</button>
                              </div>
                            </div>

                          </SwiperSlide>
                          <SwiperSlide>
                            <div className="card border-0">
                              <div className="product-image position-relative">
                                <a alt="Programa3" title="Programa3" href="#programas">
                                  {/*<img src={repo_site_assets_link("programa3.jpg")} alt="Programa3" title="Programa3" className="img-fluid" />*/}
                                  <div style={{ backgroundImage: `url(` + repo_site_assets_link("programa3.jpg") + `)` }} alt="Programa3" title="Programa3" className="img-fluid background-image"></div>
                                </a>

                              </div>
                              <div className="product-content p-3 bg-color-gray-light">
                                <div className="info mb-4">
                                  <span className="product-name">Forfait 3 dias</span>
                                  &nbsp;&#47;&nbsp;
                                  <span className="product-group">Criança</span>
                                  <div className="price float-right">40,00€</div>
                                </div>
                                <button className="btn btn-primary float-right">{language[lang].learn_more}</button>
                              </div>
                            </div>

                          </SwiperSlide>
                          <SwiperSlide>
                            <div className="card border-0">
                              <div className="product-image position-relative">
                                <a alt="Programa4" title="Programa4" href="#programas">
                                  <div style={{ backgroundImage: `url(` + repo_site_assets_link("programa4.jpg") + `)` }} alt="Programa4" title="Programa4" className="img-fluid background-image" ></div>
                                  {/*<img src={repo_site_assets_link("programa4.jpg")} alt="Programa4" title="Programa4" className="img-fluid" />*/}
                                </a>

                              </div>
                              <div className="product-content p-3 bg-color-gray-light">
                                <div className="info mb-4">
                                  <span className="product-name">Forfait Teste</span>
                                  &nbsp;&#47;&nbsp;
                                  <span className="product-group">All people</span>
                                  <div className="price float-right">50,00€</div>
                                </div>
                                <button className="btn btn-primary float-right">{language[lang].learn_more}</button>
                              </div>
                            </div>

                          </SwiperSlide>


                          {
                            /*programas.map((v, key) => {
                              return (
                                <SwiperSlide key={key}>
                                  <div className='card'>
                                    <a alt="" href="/#">
                                      <img alt='' className="img-fluid" src={v.content[0].media.image[0].link} />
                                      {parse(v.info.date.published.split('T')[0])}
                                      <p><b>{parse(v.content[0].title)}</b></p>
                                      <p>{parse(v.content[0].abstract)}</p>
                                    </a>
                                  </div>
                                </SwiperSlide>
                              )
                            })*/
                          }

                        </Swiper>
                      </div>
                      <div className="swiper-pagination-programas my-3"></div>
                    </div>
                    <div className="col-12">
                      <div className="my-2 text-right">
                        <a className="txt-btn" href="#programas" title={language[lang].see_it_all}>
                          {language[lang].see_it_all}
                          <FontAwesomeIcon icon={faLongArrowAltRight} />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="destaque_11" className="parallax d-none" /*style={{ backgroundImage: `url(` + repo_img_link("banner_pag_welcome_1.jpg") + `)` }}*/>
              <div className="container-fluid mp-mask">
                <div className="row">
                  {/*<img alt='Snow' className="img-fluid" src={repo_img_link("banner_snow.svg")} style={{ marginTop: `-1px`}} />*/}
                  <div className="container py-100">
                    <div className="row">
                      <div className="col-12">
                        {
                          /*dataDestaque.map((v, key) => {
                          //console.log('------------> V', v)
                            let link_banner = (v.info.slug !== undefined && v.info.slug !== '' ? Hosts.WEB_SITE_URI + '' + v.info.slug : Hosts.WEB_SITE_URI + 'pag/' + v.id);
                            //image = v.content[0].media.image[0].link
                            return (
                              <div key={key}>
                                  <div className="mb-5">
                                    <h3 className="titulo-primario">
                                      {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                    </h3>
                                    <p className="subtitulo-secundario">
                                      {lang === 'pt' || v.content[0].language === undefined ? v.content[0].subtitle : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].subtitle === undefined || v.content[0].language[lang_id].subtitle === '' ? v.content[0].subtitle : v.content[0].language[lang_id].subtitle)}
                                    </p>
                                  </div>
                                  <div className='d-none'>
                                    {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].text === undefined || v.content[0].language[lang_id].text === '' ? v.content[0].text : v.content[0].language[lang_id].text))}
                                  </div>
                                  <a href={link_banner} className="btn btn-primary" title={language[lang].learn_more}>
                                    {language[lang].learn_more}
                                  </a>
                              </div>
                            )
                          })*/
                        }
                      </div>
                    </div>
                  </div>
                  {/*<img alt='Snow' className="img-fluid" src={repo_img_link("banner_snow.svg")} style={{transform: `rotate(180deg)`, marginBottom: `-1px`}} />*/}
                </div>
              </div>
            </section>

            <section id="destaque_1" className="parallax" style={{ backgroundImage: `url(` + repo_img_link("banner_pag_welcome_2.jpg") + `)` }}>
              <div className="container-fluid mp-mask">
                <div className="row">
                  {/*<img alt='Snow' className="img-fluid" src={repo_img_link("banner_snow.svg")} style={{ marginTop: `-1px`}} />*/}
                  <div className="container py-100">
                    <div className="row">
                      <div className="col-12">
                        {
                          /*dataDestaque.map((v, key) => {
                          //console.log('------------> V', v)
                            let link_banner = (v.info.slug !== undefined && v.info.slug !== '' ? Hosts.WEB_SITE_URI + '' + v.info.slug : Hosts.WEB_SITE_URI + 'pag/' + v.id);
                            //image = v.content[0].media.image[0].link
                            return (
                              <div key={key}>
                                  <div className="mb-5">
                                    <h3 className="titulo-primario">
                                      {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                    </h3>
                                    <p className="subtitulo-secundario">
                                      {lang === 'pt' || v.content[0].language === undefined ? v.content[0].subtitle : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].subtitle === undefined || v.content[0].language[lang_id].subtitle === '' ? v.content[0].subtitle : v.content[0].language[lang_id].subtitle)}
                                    </p>
                                  </div>
                                  <div className='d-none'>
                                    {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].text === undefined || v.content[0].language[lang_id].text === '' ? v.content[0].text : v.content[0].language[lang_id].text))}
                                  </div>
                                  <a href={link_banner} className="btn btn-primary" title={language[lang].learn_more}>
                                    {language[lang].learn_more}
                                  </a>
                              </div>
                            )
                          })*/
                        }
                      </div>
                    </div>
                  </div>
                  {/*<img alt='Snow' className="img-fluid" src={repo_img_link("banner_snow.svg")} style={{transform: `rotate(180deg)`, marginBottom: `-1px`}} />*/}
                </div>
              </div>
            </section>

            <section id="destaque_22" className="parallax d-none" /*style={{ backgroundImage: `url(` + repo_img_link("banner_pag_welcome_2.jpg") + `)` }}*/>
              <div className="container-fluid mp-mask mb-0">
                <div className="row">
                  {/*<img alt='Snow' className="img-fluid" src={repo_img_link("banner_snow.svg")} style={{ marginTop: `-1px`}} />*/}
                  <div className="container py-100">
                    <div className="row">
                      <div className="col-12 text-right">
                        {
                          /*dataBanner2.map((v, key) => {
                            //console.log('------------> V', v)
                            let link_banner = (v.info.slug !== undefined && v.info.slug !== '' ? Hosts.WEB_SITE_URI + '' + v.info.slug : Hosts.WEB_SITE_URI + 'pag/' + v.id);
                            //image = v.content[0].media.image[0].link
                            return (
                              <div key={key}>
                                  <div className="mb-5">
                                    <h3 className="titulo-primario">
                                      {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                    </h3>
                                    <p className="subtitulo-secundario">
                                      {lang === 'pt' || v.content[0].language === undefined ? v.content[0].subtitle : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].subtitle === undefined || v.content[0].language[lang_id].subtitle === '' ? v.content[0].subtitle : v.content[0].language[lang_id].subtitle)}
                                    </p>
                                  </div>
                                  <div className='d-none'>
                                    {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].text === undefined || v.content[0].language[lang_id].text === '' ? v.content[0].text : v.content[0].language[lang_id].text))}
                                  </div>
                                  <a href={link_banner} className="btn btn-primary mb-5" title={language[lang].learn_more}>
                                    {language[lang].learn_more}
                                  </a>
                              </div>
                            )
                          })*/
                        }
                      </div>
                    </div>
                  </div>
                  {/*<img alt='Snow' className="img-fluid d-none" src={repo_img_link("banner_snow.svg")} style={{transform: `rotate(180deg)`, marginBottom: `-1px`}}/>*/}
                </div>
              </div>
            </section>

            <section id="destaque_2" className="parallax" style={{ backgroundImage: `url(` + repo_img_link("banner_pag_welcome_1.jpg") + `)` }}>
              <div className="container-fluid mp-mask mb-0">
                <div className="row">
                  {/*<img alt='Snow' className="img-fluid" src={repo_img_link("banner_snow.svg")} style={{ marginTop: `-1px`}} />*/}
                  <div className="container py-100">
                    <div className="row">
                      <div className="col-12">
                        {
                          /*dataBanner2.map((v, key) => {
                            //console.log('------------> V', v)
                            let link_banner = (v.info.slug !== undefined && v.info.slug !== '' ? Hosts.WEB_SITE_URI + '' + v.info.slug : Hosts.WEB_SITE_URI + 'pag/' + v.id);
                            //image = v.content[0].media.image[0].link
                            return (
                              <div key={key}>
                                  <div className="mb-5">
                                    <h3 className="titulo-primario">
                                      {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                    </h3>
                                    <p className="subtitulo-secundario">
                                      {lang === 'pt' || v.content[0].language === undefined ? v.content[0].subtitle : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].subtitle === undefined || v.content[0].language[lang_id].subtitle === '' ? v.content[0].subtitle : v.content[0].language[lang_id].subtitle)}
                                    </p>
                                  </div>
                                  <div className='d-none'>
                                    {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].text === undefined || v.content[0].language[lang_id].text === '' ? v.content[0].text : v.content[0].language[lang_id].text))}
                                  </div>
                                  <a href={link_banner} className="btn btn-primary mb-5" title={language[lang].learn_more}>
                                    {language[lang].learn_more}
                                  </a>
                              </div>
                            )
                          })*/
                        }
                      </div>
                    </div>
                  </div>
                  {/*<img alt='Snow' className="img-fluid d-none" src={repo_img_link("banner_snow.svg")} style={{transform: `rotate(180deg)`, marginBottom: `-1px`}}/>*/}
                </div>
              </div>
            </section>

            <section id="banner_loja" className="parallax d-none" style={{ backgroundImage: `url(` + repo_img_link("banner-atendimento.jpg") + `)` }}>
              <div className="container-fluid py-100 overlay-img">
                <div className="row">
                  <div className="container">
                    <div className="row text-center">
                      <div className="col-12 my-5">
                        <h3 className="titulo-primario font-weight-bold text-white" /*data-bg-text={language[lang].testimonials}*/>
                          {parse(language[lang].store_banner_text)}
                        </h3>
                        <a href={Hosts.WEB_SITE_URI + 'store'} className="btn btn-secondary mt-3" /*title={language[lang].learn_more}*/>
                          {language[lang].learn_more}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="parcerias" className='d-none'>
              <div className="container-fluid py-5">
                <div className="container">
                  <div className="row">
                    <div className="col-12 text-center my-5">
                      <h3 className="titulo-primario" data-bg-text={language[lang].contenthips}>
                        {language[lang].contenthips}
                      </h3>
                      {/*<h1 className="vertical-title-right">
                          {language[lang].contenthips}
                      </h1>*/}
                    </div>
                    <div className="col-12 d-none">
                      <div className="swiper swiper-container swiper-parcerias">
                        <Swiper
                          modules={[Navigation, Autoplay, Pagination, Scrollbar, A11y]}
                          spaceBetween={15}
                          slidesPerView={2}
                          slidesPerGroup={2}
                          //navigation={dataParcerias.length > 1 ? true : false}
                          /*navigation={{
                              nextEl: '.swiper-parcerias-button-next',
                              prevEl: '.swiper-parcerias-button-prev',
                          }}*/
                          loop={true}
                          speed={7000}
                          autoplay={{
                            delay: 5000,
                            disableOnInteraction: false
                          }}
                          //effect="fade"
                          //pagination={dataParcerias.length > 1 ? true : false}
                          pagination={{
                            el: '.swiper-pagination-parcerias',
                            clickable: true
                          }}
                          breakpoints={{
                            // when window width is >= 0px
                            0: {
                              slidesPerView: 2,
                              slidesPerGroup: 2
                            },
                            // when window width is >= 768px
                            768: {
                              slidesPerView: 3,
                              slidesPerGroup: 3
                            },
                            992: {
                              slidesPerView: 5,
                              slidesPerGroup: 5
                            },
                          }}
                        //scrollbar={{ draggable: true }}
                        //onSwiper={(swiper) => console.log(swiper)}
                        //onSlideChange={() => console.log('slide change')}
                        >

                          {
                            dataParcerias.map((v, key) => {

                              //console.log(v)
                              return (

                                v.content[0].media.image.map((v2, key2) => {

                                  //check if link has http (if not, add it to link)
                                  if (v2 !== undefined && v2 !== null && v2.url !== undefined && v2.url !== null && v2.url !== '' && v2.url.substr(0, 4) !== 'http') {
                                    v2.url = 'http://' + v2.url;
                                    //console.log(v2.url)

                                  }
                                  //console.log(v2)
                                  return (
                                    <SwiperSlide key={key2}>
                                      <div className="card">
                                        <div className="product-image position-relative">

                                          {
                                            v2 !== undefined && v2 !== null && v2.url !== undefined && v2.url !== null && v2.url !== '' ?
                                              <a title={v2.name} href={v2.url} target="_blank" rel="noreferrer">
                                                <img alt={v2.name} title={v2.link} className="img-fluid" src={v2.link} />
                                                {/*<p>{v2.name}</p>*/}
                                              </a>
                                              :

                                              <img alt={v2.name} title={(v2.link.includes(v2.name) || v2.name.includes('webp') || v2.name.includes('jpg') || v2.name.includes('png')) ? '' : v2.name} className="img-fluid" src={v2.link} />
                                          }
                                        </div>
                                      </div>
                                    </SwiperSlide>
                                  )
                                })

                              )
                            })
                          }

                        </Swiper>
                      </div>
                      <div className="swiper-pagination-parcerias my-3"></div>
                    </div>
                    <div className="col-12">
                      <div className="row row-cols-2 row-cols-sm-3 row-cols-md-5 justify-content-center">
                        {
                          dataParcerias.map((v, key) => {

                            //console.log(v)
                            return (

                              v.content[0].media.image.map((v2, key2) => {

                                //check if link has http (if not, add it to link)
                                if (v2 !== undefined && v2 !== null && v2.url !== undefined && v2.url !== null && v2.url !== '' && v2.url.substr(0, 4) !== 'http') {
                                  v2.url = 'http://' + v2.url;
                                  //console.log(v2.url)

                                }

                                //console.log(v2)
                                return (
                                  <div className="col mb-4" key={key2}>
                                    <div className="card">
                                      <div className="partner-image position-relative">

                                        {

                                          v2 !== undefined && v2 !== null && v2.url !== undefined && v2.url !== null && v2.url !== '' /*&& v2.url.substr(0, 4) !== 'http'*/ ?
                                            // v2 !== null && v2.url !== undefined && v2.url !== '' ?
                                            <a alt={v2.name} href={v2.url} target="_blank" rel="noreferrer">
                                              <AssecImage
                                                linkImage={v2.link !== undefined ? v2.link : repo_img_link('nophoto.png')}
                                                width="640"
                                                height="640"
                                                fit='fit'
                                                type='img'
                                                sClass='img-fluid'
                                                alt={v2.name}
                                                title={v2.url}
                                              />
                                            </a>
                                            :
                                            <AssecImage
                                              linkImage={v2.link !== undefined ? v2.link : repo_img_link('nophoto.png')}
                                              width="640"
                                              height="640"
                                              fit='fit'
                                              type='img'
                                              sClass='img-fluid'
                                              alt={v2.name}
                                              title={(v2.link.includes(v2.name) || v2.name.includes('webp') || v2.name.includes('jpg') || v2.name.includes('png')) ? '' : v2.name}
                                            />
                                        }

                                      </div>
                                    </div>
                                  </div>
                                )
                              })

                            )
                          })
                        }
                      </div>
                    </div>
                    {/*<div className="col-12 d-none">
                        <div className="mt-5 text-right">
                          <a className="txt-btn" href="#parcerias" title={language[lang].see_it_all}>
                            {language[lang].see_it_all}
                            <FontAwesomeIcon icon={faLongArrowAltRight} />
                          </a>
                        </div>
                      </div>*/}
                  </div>
                </div>
              </div>
            </section>

            <section id="opinion" className="parallax d-none" style={{ backgroundImage: `url(` + repo_img_link("banner-testemunhos.jpg") + `)` }}>
              <div className="container-fluid py-5 overlay-img">
                <div className="row">
                  <div className="container">
                    <div className="row">
                      <div className="col-12 text-center mt-5">
                        <h3 className="titulo-primario text-white" data-bg-text={language[lang].testimonials}>
                          {language[lang].testimonials}
                        </h3>
                        {/*<h1 className="vertical-title-left">
                          {language[lang].testimonials}
                        </h1>*/}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="swiper swiper-container swiper-testemunhos">
                          <Swiper
                            modules={[Autoplay, Navigation, EffectFade, Pagination, Scrollbar, A11y]}

                            speed={8000}
                            loop={false}
                            autoplay={{
                              delay: 5000,
                              disableOnInteraction: false,
                            }}

                            spaceBetween={0}
                            //centeredSlides={true}
                            //centerInsufficientSlides={true}
                            slidesPerView={1}
                            //navigation
                            pagination={{
                              el: '.swiper-pagination-testemunhos',
                              clickable: true
                            }}
                            breakpoints={{
                              // when window width is >= 0px
                              /*0: {
                                slidesPerView: 1,
                              },*/
                              // when window width is >= 768px
                              768: {
                                slidesPerView: 2,
                              },
                              992: {
                                slidesPerView: 2,
                              },
                            }}
                          //scrollbar={{ draggable: true }}
                          >
                            {
                              dataTestimony.map((v, key) => {
                                return (
                                  <SwiperSlide key={key} className='p-4'>
                                    {/*<img src={repo_site_assets_link("aspas.svg")} alt={language[lang].testimonials} title={language[lang].testimonials} className="img-fluid mb-4" />*/}
                                    <div className="testimonial-text">
                                      {parse(v.content[0].message)}
                                    </div>
                                    <div className='testimonial-title text-white'>
                                      <b>{parse(v.content[0].name)}</b>
                                      {
                                        v.content[0].address !== '' ?
                                          <b>
                                            &nbsp;&#45;&nbsp;
                                            {parse(v.content[0].address)}
                                          </b>
                                          : null
                                      }
                                    </div>
                                    <div className="small text-white">
                                      {/*v.info.date.creation.split('T')[0]*/}
                                      {new Date(v.info.date.creation).toLocaleDateString("pt-PT", { day: "numeric", month: "long", year: "numeric" })}
                                    </div>
                                  </SwiperSlide>
                                )
                              })
                            }

                          </Swiper>
                        </div>
                        <div className="swiper-pagination-testemunhos px-4 px-lg-0 my-3"></div>
                        <div className="col-12 my-4 my-md-2 text-center">
                          <button type="button" /*onClick={() => setShow(true)}*/ data-toggle="modal" data-target={"#modal_form"} className="btn btn-secondary">{language[lang].testimonials_button_message}</button>
                          <Modal onClose={() => setShow(false)} show={show} />
                        </div>
                      </div>
                      {/*<div className="col-12 col-md-6 p-0 d-none d-sm-block">
                        <div style={{ backgroundImage: `url(` + repo_site_assets_link("testemunhos_image.jpg") + `)` }} alt={language[lang].testimonials} title={language[lang].testimonials} className="img-fluid background-image rounded-20" ></div>
                        <img src={repo_site_assets_link("testemunhos_image.jpg")} alt={language[lang].testimonials} title={language[lang].testimonials} className="img-fluid rounded-20" />
                      </div>*/}
                    </div>
                  </div>
                </div>
              </div>
            </section>

          </div>
        :
          null
        }

        <Footer pag_welcome={true} />

      </div>
  )
}

export default Pagina;